import { SubscribeTarifarioRequest } from 'src/app/core/models/request/subscribe-tarifario.request';

export function toSubscribeTarifario(
  subscribe: boolean,
  tipoMedioPagoId: number[],
  agrupador: boolean = false
): SubscribeTarifarioRequest {
  let request = new SubscribeTarifarioRequest();
  request.operacion = subscribe ? 'S' : 'D';
  request.tiposMedioPagoId = tipoMedioPagoId;
  request.gatewayAgrupador = agrupador;
  return request;
}
